import moment from "moment"

export function getMonthNameFromNumber(number) {
  // January is equal to 0
  return moment()
    .month(number)
    .format("MMMM")
}
